import {
   differenceInDays,
   differenceInMinutes,
   differenceInSeconds,
   format,
   isSameYear
} from 'date-fns'
import parse from 'date-fns/parse'

import {
   DUE_DATE_SAME_YEAR_FORMAT,
   HOME_PAGE_DATE_TIME_FORMAT,
   SERVER_DATE_FORMAT,
   SERVER_TIME_FORMAT,
   TIME_FORMAT
} from '@flowwai-frontend/shared/constants'

export function getDateObjectFromDateString(date: string): Date {
   const result = parse(date)
   return result
}

export function getDateFromDateObject(
   date: Date,
   customFormat = SERVER_DATE_FORMAT
): string {
   return format(date, customFormat)
}

export function getTimeFromDateObject(
   date: Date,
   customFormat = SERVER_TIME_FORMAT
): string {
   return format(date, customFormat)
}

export function getDurationFromTheDate(date: string): number {
   const today = new Date()
   const dateFromString = getDateObjectFromDateString(date)

   return differenceInSeconds(today, dateFromString)
}

export function getMinutesFromTheDate(date: string): number {
   const today = new Date()
   const dateFromString = getDateObjectFromDateString(date)

   return differenceInMinutes(today, dateFromString)
}

export function getNumberOfDaysFromTheDate(date: string): number {
   const today = new Date()
   const dateFromString = getDateObjectFromDateString(date)

   return differenceInDays(today, dateFromString)
}

export const getDateFormatForCrossBrowserSupport = (date: string) => {
   const updatedFormatForCrossBrowserSupport = date
      .split('-')
      .join('/')
      .split('.')[0]
   return updatedFormatForCrossBrowserSupport
}

export const getNegPosDifferenceInDays = (
   fromDate: string,
   toDate: string
): number => {
   const difference = differenceInDays(toDate, fromDate)
   return difference
}

export const isCurrentYear = (fromDate: Date, toDate: Date): boolean =>
   isSameYear(fromDate, toDate)

export const getDateTimeFormat = (createdAtTime: string, t) => {
   //TODO: need to add type
   const prefix = 'notifications:notifications.notificationCreatedAtTime'
   const diffInDays = getNumberOfDaysFromTheDate(createdAtTime)
   const diffInMinutes = getMinutesFromTheDate(createdAtTime)
   const diffInSeconds = getDurationFromTheDate(createdAtTime)
   const dateTimeObj = getDateObjectFromDateString(createdAtTime)
   if (diffInDays <= 1) {
      if (diffInDays < 1) {
         if (diffInMinutes <= 119) {
            if (diffInMinutes < 60) {
               if (diffInSeconds <= 119) {
                  if (diffInSeconds < 60) {
                     return t(`${prefix}.notificationCreatedAtTimeInSeconds`, {
                        seconds: diffInSeconds,
                        count: diffInSeconds
                     })
                  }
                  return t(`${prefix}.notificationCreatedAtTimeInMinutes`, {
                     minutes: 1,
                     count: 1
                  })
               }
               return t(`${prefix}.notificationCreatedAtTimeInMinutes`, {
                  minutes: Math.floor(diffInSeconds / 60),
                  count: Math.floor(diffInSeconds / 60)
               })
            }
            return t(`${prefix}.notificationCreatedAtTimeInHours`, {
               hours: 1,
               count: 1
            })
         }
         return t(`${prefix}.notificationCreatedAtTimeInHours`, {
            hours: Math.floor(diffInMinutes / 60),
            count: Math.floor(diffInMinutes / 60)
         })
      }
      return t(`${prefix}.notificationCreatedAtTimeInDays`, {
         days: 1,
         count: 1
      })
   }
   const date = getDateFromDateObject(dateTimeObj, HOME_PAGE_DATE_TIME_FORMAT)
   const time = getDateFromDateObject(dateTimeObj, TIME_FORMAT)
   return `${date} at ${time}`
}

export const getFormattedDate = (date: Date, t, format?: string): string => {
   const diffDays = getNegPosDifferenceInDays(
      getDateFromDateObject(new Date()),
      getDateFromDateObject(date)
   )

   if (diffDays === 0) {
      return `${t('today')} at ${getDateFromDateObject(
         date,
         format ? format : TIME_FORMAT
      )}`
   } else if (diffDays === -1) {
      return `${t('yesterday')} at ${getDateFromDateObject(
         date,
         format ? format : TIME_FORMAT
      )}`
   }

   if (isCurrentYear(new Date(), date)) {
      return getDateFromDateObject(
         date,
         format ? format : DUE_DATE_SAME_YEAR_FORMAT
      )
   }

   return getDateFromDateObject(date, format)
}

export const getTimeDifferenceInSeconds = (
   dateLeft: Date | string | number,
   dateRight: Date | string | number
): number => differenceInSeconds(dateLeft, dateRight)
